import { queryOptions } from '@tanstack/react-query'
import getFaq from '../api/get-faq'

export const getFaqQueryKey = (role: 'client' | 'staff') => ['faq', role] as const

export const getFaqQueryOptions = (role: 'client' | 'staff') =>
  queryOptions({
    queryKey: getFaqQueryKey(role),
    queryFn: () => getFaq(role),
    staleTime: Infinity,
    gcTime: Infinity,
  })
